import MenuList from '@mui/material/MenuList';
import s from './MLMenuList.module.css';

function MLMenuList({ children, onKeyDown, autoFocus = true }) {
  return (
    <MenuList
      classes={{ root: s.root }}
      onKeyDown={onKeyDown}
      autoFocus={autoFocus}
      autoFocusItem={autoFocus}
    >
      {children}
    </MenuList>
  );
}

export default MLMenuList;
